export default __webpack_public_path__ + "static/media/help.95331f5a.svg";